<template>
  <v-layout
    v-bind="layout"
    justify-center
    align-center
    class="mb-4 warning--text"
    style="word-break: break-word"
  >
    <v-layout>
      <v-icon
        color="warning"
        class="mr-3"
        medium
      >
        priority_high
      </v-icon>
      <div>
        <strong>{{ $t('signupEmailWarning_1') }}</strong>
        {{ $t('signupEmailWarning_2') }}
      </div>
    </v-layout>
    <v-btn
      flat
      color="warning"
      :to="{name: 'account'}"
      round
    >
      {{ $t('changeEmail') }}
    </v-btn>
  </v-layout>
</template>

<script>
export default {
  computed: {
    layout() {
      if (this.$vuetify.breakpoint.xsOnly) {
        return {column: true};
      }
      return {row: true};
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/GenericEmailWarningWithButton.vue